<template>
  <vs-table ref="table" class="pb-5" :data="lineItems">
    <template slot="thead">
      <vs-th v-for="(header, index) in headers" :key="`header-${index}`" >
        {{ header }}
      </vs-th>
    </template>

    <template slot-scope="{data}">
      <tbody v-for="(lineItem, index) in data" :data="lineItems" :key="`lineItem-${index}`">
      <vs-tr class="cursor-pointer">
        <vs-td>
          <p class="font-medium truncate">{{ lineItem.sku }}</p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">{{ lineItem.name }}</p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">${{ lineItem.price }} </p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">${{ lineItem.tax }}</p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">${{ lineItem.discount }}</p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">{{ lineItem.quantity }}</p>
        </vs-td>
        <vs-td>
          <p class="font-medium truncate">{{ lineItem.requiresShipping ? 'Yes' : 'No' }}</p>
        </vs-td>
      </vs-tr>
      </tbody>
    </template>
  </vs-table>
</template>

<script>

export default {
  props: [
    'lineItems',
    'headers'
  ]
}
</script>
